import { DEFAULT_LOCATIONS, QUANTUM, DROPDOWN_AUTOCOMPLETE } from 'utils/constants';
import { selectToken, EnvTokenMap } from 'utils/selectToken';
import { IndividualLocalClientConfig } from './localConfig.types';

export const apiTokens: EnvTokenMap = {
  dev: 'Token 101f6deecb3ab1b0bcda7a15295dd3be741e6d4f',
  staging: 'Token 83f155c4100c446c5030c6d13f0935c05b5c38fe',
  prod: 'Token ccc508e7e9bd2e1c0ae764ab7c7d8744c705c637',
};

const token = selectToken(apiTokens);

const quantumConfig: IndividualLocalClientConfig = {
  // config name used for fetching client config from fusion
  CONFIG_NAME: 'quantum',

  API_TOKEN: token,
  EMBOLD_CLIENT: QUANTUM,

  // login
  SHOW_REGION_SELECTOR: true,

  // other
  DEFAULT_LOCATION: { ...DEFAULT_LOCATIONS.Nashville },
  LOGIN_NETWORK_NAME: 'quantumUserId',

  // content
  DISPLAY_NAME: 'Quantum Health',
  FORM_VARIANT: DROPDOWN_AUTOCOMPLETE,
  NO_WELCOME_LINK: true,
};

export default quantumConfig;
